import React, { useState } from "react";
import { Container, Divider, Card, Button, Typography, Grid, CardActions, LinearProgress, InputAdornment, Skeleton } from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { usePrivateDBDetailsQuery, usePrivateDBDeleteMutation } from "services/privatedb";
import { useUserDetailsQuery } from 'services/user'
import { useOrgDetailsQuery } from 'services/org';
import { useGetRoleByCodeQuery } from "services/role";




const PrivateDBDetails = (props) => {

    const navi = useNavigate();
    const [disableButton, setDisableButton] = useState(false);
    const { id } = useParams();
    const [privateDBDeleteMutation, { isLoading: isUpdating }] = usePrivateDBDeleteMutation();

    const handleCancel = () => {
        navi("/privatedb/list")
    }

    const handleDelete = () => {
        setDisableButton(true)
        privateDBDeleteMutation({ id: id })
            .unwrap()
            .then(result => {
                setDisableButton(false);
                navi("/privatedb/list")
            })
            .catch(err => {
                setDisableButton(false);
                navi("/privatedb/list")
            })

    }

    const { privateDBDetails, privatedbStatus, privatedbLoading, fetching } = usePrivateDBDetailsQuery({ id: id },
        {
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                privateDBDetails: data || {},
                privatedbStatus: status,
                privatedbLoading: isLoading,
                fetching: isFetching
            })
        }
    );

    const { assignedTo } = useUserDetailsQuery({ id: privateDBDetails.userId },
        {
            skip: !privateDBDetails.userId,
            selectFromResult: ({ data }) => ({
                assignedTo: data || {},
            })
        }
    );

    const { role } = useGetRoleByCodeQuery({ code: assignedTo.role },
        {
            skip: !assignedTo.role,
            selectFromResult: ({ data }) => ({
                role: data || {},
            })
        }
    );

    const { org } = useOrgDetailsQuery({ id: assignedTo.orgId },
        {
            skip: !assignedTo.orgId,
            selectFromResult: ({ data }) => ({
                org: data || {},
            })
        }
    );

    return (
        <React.Fragment>
            <CommonListHeader value={{ title: `TSA+ DB: ${privateDBDetails.id}`, description: "You are viewing privateDB details. To edit click edit button" }} />
            <Container maxWidth={'xl'} disableGutters sx={{ padding: "10px" }}>
                <Card elevation={3}>
                    {disableButton ? <LinearProgress /> : ''}
                    <Grid container sx={{ padding: "10px" }}>
                        <Grid container item md={12} display="flex" justifyContent="space-between" sx={{ backgroundColor: '#bdbdbd', padding: "10px" }}>
                            <Grid container item md={6} display="flex" direction="column" >
                                <Typography variant="h6">{`TSA+ DB: ${privateDBDetails.id}`}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Case Name:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails.case_name : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} er display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Tire Brand/Type:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.brand : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">P/LT/Eur-Metric:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.metric : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider className={{ margin: "10px" }} />
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Section Width:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.section_width : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Aspect Ratio:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.aspect_ratio : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Rim Diameter:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.rim_diameter : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider className={{ margin: "10px" }} />
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Plant Code:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.plant_code : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Size Code:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.size_code : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Aux Info.:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.aux_info : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider className={{ margin: "10px" }} />
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Cure Week/Year:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.cure_wkyr : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Speed Rating:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.speed_rating : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Load Range:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.load_range : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider className={{ margin: "10px" }} />
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Construction:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.construction : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Punctures/Repairs:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails.repairs : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Min. Tread Depth: (32nds of in.)</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.min_tread_depth : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider className={{ margin: "10px" }} />
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Max. Tread Depth: (32nds of in.)</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.max_tread_depth : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Failure Mode:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.failure_mode : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">DOT Number:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.dot : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container item md={12} display="flex" justifyContent="space-between" sx={{ backgroundColor: '#bdbdbd', padding: "10px" }}>
                            <Grid container item md={6} display="flex" direction="column">
                                <Typography variant="h6">Failure Factors</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={6}>
                                    <Typography variant="body1">Manufacture Defect:</Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography variant="body1">{privateDBDetails?.mfg_defect ? 'YES' : 'NO'}</Typography>
                                </Grid>
                            </Grid>

                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Design Defect:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails?.design_defect ? 'YES' : 'NO'}</Typography>
                                </Grid>
                            </Grid>

                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Aging:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails?.aging ? 'YES' : 'NO'}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>


                        <Grid container item md={12} display="flex" justifyContent="space-between" sx={{ backgroundColor: '#bdbdbd', padding: "10px" }}>
                            <Grid container item md={6} display="flex" direction="column">
                                <Typography variant="h6">TSA+ Alerts</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={6}>
                                    <Typography variant="body1">Defective Tire Alert</Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography variant="body1">{privateDBDetails?.defective_tire_alert ? 'YES' : 'NO'}</Typography>
                                </Grid>
                            </Grid>

                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={6}>
                                    <Typography variant="body1">Early Warning Alert</Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography variant="body1">{privateDBDetails?.early_warning_alert ? 'YES' : 'NO'}</Typography>
                                </Grid>
                            </Grid>

                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={6}>
                                    <Typography variant="body1">Early Degradation Alert</Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography variant="body1">{privateDBDetails?.early_degradation_alert ? 'YES' : 'NO'}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={6}>
                                    <Typography variant="body1">Forensic Investigation Alert</Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography variant="body1">{privateDBDetails?.forensic_investigation_alert ? 'YES' : 'NO'}</Typography>
                                </Grid>
                            </Grid>

                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={6}>
                                    <Typography variant="body1">Reported Tire Failure Alert</Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography variant="body1">{privateDBDetails?.reported_tire_failure_alert ? 'YES' : 'NO'}</Typography>
                                </Grid>
                            </Grid>

                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={6}>
                                    <Typography variant="body1">Dealer Reported Tire Failure Alert</Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography variant="body1">{privateDBDetails?.dealer_reported_tire_failure_alert ? 'YES' : 'NO'}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={6}>
                                    <Typography variant="body1">Reported Early Warning Alert</Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography variant="body1">{privateDBDetails?.reported_early_waring_alert ? 'YES' : 'NO'}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>


                        <Grid container item md={12} display="flex" justifyContent="space-between" sx={{ backgroundColor: '#bdbdbd', padding: "10px" }}>
                            <Grid container item md={6} display="flex" direction="column">
                                <Typography variant="h6">Vehicle Information</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">VIN:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.vin : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">YEAR: </Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.car_year : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">MAKE:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.car_make : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">MODEL</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{privateDBDetails ? privateDBDetails?.car_model : <Skeleton />}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container item md={12} display="flex" justifyContent="space-between" sx={{ backgroundColor: '#bdbdbd', padding: "10px" }}>
                            <Grid container item md={6} display="flex" direction="column">
                                <Typography variant="h6">User Information</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Assigned To:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{`${assignedTo?.firstName} ${assignedTo?.lastName}`}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Role:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{`${role?.name}`}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item md={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                                <Grid item md={3}>
                                    <Typography variant="body1">Organisation:</Typography>
                                </Grid>
                                <Grid item md={9}>
                                    <Typography variant="body1">{`${org?.name || ''}`}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider sx={{ marginY: "10px" }} />
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Status</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.status ? 'ACTIVE' : 'INACTIVE'}</Typography>
                            </Grid>
                        </Grid>

                        <CardActions sx={{ padding: "15px" }}>
                            <Button
                                disabled={disableButton}
                                variant="contained"
                                color='primary'
                                type="submit"
                                onClick={() => navi(`/privatedb/edit/${privateDBDetails?.id}`)}
                            >
                                Edit
                            </Button>
                            <Button
                                disabled={disableButton}
                                variant="outlined"
                                type="submit"
                                onClick={() => handleCancel()}
                            >
                                Cancel
                            </Button>
                            <Typography sx={{ flexGrow: 1 }} />
                            <Button
                                disabled={disableButton}
                                variant="contained"
                                color='primary'
                                type="submit"
                                onClick={() => navi(`/privatedb/details/assign/${privateDBDetails?.id}`)}
                            >
                                Assign
                            </Button>
                            <Button
                                disabled={disableButton}
                                variant="outlined"
                                type="submit"
                                onClick={() => handleDelete()}
                                color={'warning'}
                            >
                                delete
                            </Button>
                        </CardActions>
                    </Grid>
                </Card>
            </Container>
        </React.Fragment>
    )


}

export default PrivateDBDetails;